export default {
  checkboxLabel: {
    id: 'asp_seller_action_bar_next_task_checkbox',
    defaultMessage: 'Go to the next task after confirming your action.',
  },
}
